import React from "react";
import NoDataFound from "../../assets/Images/nodatafound.jpg";
import { useNavigate } from "react-router-dom";
import { Button } from "@progress/kendo-react-buttons";
import IconComponent from "./IconComponent";
import { MdKeyboardBackspace } from "react-icons/md";

const NoDataFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        minHeight: "90vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img
        src={NoDataFound}
        alt={"No Data Image"}
        style={{ width: "100%", maxWidth: 600 }}
      />
      <Button
        themeColor={"primary"}
        fillMode="solid"
        title="Back"
        onClick={() => navigate("/")}
      >
        <IconComponent
          icon={MdKeyboardBackspace}
          style={{ fontSize: "20px" }}
        />{" "}
        Back To Home
      </Button>
    </div>
  );
};

export default NoDataFoundPage;
